import { render, staticRenderFns } from "./ApiVersionCard.vue?vue&type=template&id=3a61d0e9&scoped=true"
import script from "./ApiVersionCard.ts?vue&type=script&lang=ts&external"
export * from "./ApiVersionCard.ts?vue&type=script&lang=ts&external"
import style0 from "./ApiVersionCard.vue?vue&type=style&index=0&id=3a61d0e9&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3a61d0e9",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/codebuild/output/src120839944/src/sctd-frontend/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('3a61d0e9')) {
      api.createRecord('3a61d0e9', component.options)
    } else {
      api.reload('3a61d0e9', component.options)
    }
    module.hot.accept("./ApiVersionCard.vue?vue&type=template&id=3a61d0e9&scoped=true", function () {
      api.rerender('3a61d0e9', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/Modules/User/components/ApiVersionCard/ApiVersionCard.vue"
export default component.exports